module.exports = {
	"name": "MapWidget",
	"version": "2.2.0-alpha.1",
	"description": "",
	"repository": {
		"type": "git",
		"url": "https://github.com/graylog-plugin-map-widget"
	},
	"scripts": {
		"build": "webpack --bail"
	},
	"keywords": [
		"graylog"
	],
	"author": "Graylog, Inc. <hello@graylog.com>",
	"license": "GPL-3.0",
	"dependencies": {
		"leaflet": "~0.7.7",
		"react-leaflet": "~0.10.0"
	},
	"devDependencies": {
		"graylog-web-plugin": "file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 593
// module chunks = 0